// extracted by mini-css-extract-plugin
export default {"productDescription":"M_-z","featuredDescription":"N_-z","description":"O_-z","more":"P_-z","descriptionSku":"Q_-z"};